import { useParams, useRouter } from "next/navigation";

import { useCallback, useRef, useState } from "react";

import type { KeyboardEvent } from "react";

export const useNotFoundSearch = () => {
  const router = useRouter();
  const { locale } = useParams<{ locale: string }>();
  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState("");

  const submit = useCallback(() => {
    const trimmed = value.trim();
    const target = trimmed
      ? `/${locale}/shop/search/${encodeURIComponent(trimmed)}`
      : `/${locale}/shop`;

    router.push(target);
  }, [value, locale, router]);

  const onKeyDown = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") {
        event.preventDefault();
        submit();
      }
    },
    [submit],
  );

  return { value, setValue, submit, onKeyDown, inputRef };
};
